<!-- ----------------------------------------------- -->
<template>
  <v-app v-if="config" class="secondary app-frame">
    <notification-pc v-if="showNotification && mode === 'pc'"></notification-pc>
    <notification-mb v-if="showNotification && mode === 'mb'"></notification-mb>
    <router-view name="header"></router-view>
    <v-row
      id="contents"
      v-if="mode === 'pc' || mode === 'mb' || mode === 'rp'"
      class="mx-0"
    >
      <v-row id="map" class="ma-0">
        <rp-map v-if="mode === 'rp'"></rp-map>
        <kwb-map v-else></kwb-map>
      </v-row>
      <div
        id="panel"
        v-if="mode === 'pc'"
        :class="{ panel: !pcPanelMode, panelLarge: pcPanelMode }"
      >
        <router-view name="panel"></router-view>
      </div>
      <router-view name="dlg"></router-view>
    </v-row>
    <v-row v-if="mode === 'pcfull'" class="mx-0 ap-box-full">
      <router-view name="fullContents"></router-view>
    </v-row>
  </v-app>
</template>
<!-- ----------------------------------------------- -->
<script>
import mixin from "./lib/mixin.js";
import WebStorage from "./lib/webStorage.js";
import Util from "./lib/util.js";
import KwbMap from "./views/Map";
import RpMap from "./views/rp/RpMap";
import NotificationPc from "./views/pc/Notification";
import NotificationMb from "./views/mb/Notification";

export default {
  name: "App",
  mixins: [mixin],
  components: {
    KwbMap,
    RpMap,
    NotificationPc,
    NotificationMb,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        pageName: {
          overview: "概況",
          riverwarnList: "発表情報一覧",
          riverwarn: "発表情報",
          tmList: "観測所一覧",
          tmObs: "観測所情報",
          radar: "レーダ雨量",
          inundation: "浸水想定",
          setting: "表示設定",
          registPoint: "登録地点情報",
          administrator: "管理者",
          overList: "基準値超過観測所一覧",
          info: "お知らせ",
        },
      },
    };
  },
  beforeCreate() {
    // 観測日時(ファイル取得用)の初期値設定
    // ファイル取得失敗とならないよう、現在時刻より10分前の時間(10分単位で切り捨て)を設定
    let nowTime = Util.toDate();
    let initTime = Util.subMinutes(nowTime, 10).toDate();
    initTime.setMinutes(Math.floor(initTime.getMinutes() / 10) * 10);
    this.$store.commit("app/setAppTimeRound", initTime);
    this.$store.commit("app/setAppTimeRoundRw", initTime);

    // 設定情報を読み込み
    this.$store.dispatch("app/initConfig");

    // referrerを設定
    this.$store.commit("app/setReferrer", document.referrer);

    // 最新値ファイル用欠測判定時間を設定
    this.$store.dispatch("Telemeter/getMissingTime");
  },
  created() {
    // 画面が縦長の場合、簡易版起動の場合はモバイルモードに変更
    if (location.pathname.indexOf("mb") <= 0 && this.$route.path != "/rp") {
      if (
        (window.innerWidth < window.innerHeight ||
          global.KWB_MODE == "reduction") &&
        !location.pathname.startsWith("/kawabou/twitterCheck") &&
        !location.pathname.startsWith("/kawabou/printPreview")
      ) {
        this.routerPushChangeMb(this.$route.path);
      }
    }

    // 水防団モード設定
    this.setFldCtlParty();
    // 検索ダイアログの表示有無を設定
    this.setShowSrchDlg();
    // パネル拡大モード設定
    this.setPcPanelMode();
    // 水位表示設定
    this.setStgMode();

    // URLによるページタイトル設定
    const path = location.pathname;
    if (path.endsWith("/pcfull/ovlist")) {
      this.setPageTitle(this.text.pageName.overList);
    } else if (path.endsWith("/pcfull/info")) {
      this.setPageTitle(this.text.pageName.info);
    } else if (path.endsWith("/pcfull/info/detail")) {
      this.setPageTitle(this.text.pageName.info);
    } else if (path.endsWith("/pcfull/tm")) {
      this.setPageTitle(this.text.pageName.tmObs);
    }
  },
  computed: {
    /**
     * 画面の表示モード（appストアのmodeを参照）
     */
    mode: {
      get() {
        return this.$store.state.app.mode;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /** PCパネル拡大表示モード */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** 通知許可の表示 */
    showNotification: {
      get() {
        return this.$store.state.app.showNotification;
      },
    },
    /** 観測日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      },
    },
  },
  mounted: function() {
    this.$log.info("[app]location.pathname:" + location.pathname);
    if (
      (location.pathname == "/kawabou/pc" ||
        location.pathname == "/kawabou/" ||
        location.pathname == "/kawabou/ipTopGaikyo.do") &&
      !location.pathname.startsWith("/kawabou/twitterCheck") &&
      !location.pathname.startsWith("/kawabou/printPreview")
    ) {
      this.routerPcHome();
    }

    if (
      location.pathname.startsWith("/kawabou/pcfull") ||
      location.pathname.startsWith("/kawabou/twitterCheck") ||
      location.pathname.startsWith("/kawabou/pc/mytimeline") ||
      location.pathname.startsWith("/kawabou/printPreview")
    ) {
      this.$store.commit("app/setMode", "pcfull");
    } else if (location.pathname.startsWith("/kawabou/mbfull")) {
      this.$store.commit("app/setMode", "mbfull");
    } else if (location.pathname.startsWith("/kawabou/mb")) {
      this.$store.commit("app/setMode", "mb");
    } else if (location.pathname.startsWith("/kawabou/rp")) {
      this.$store.commit("app/setMode", "rp");
    } else {
      this.$store.commit("app/setMode", "pc");
    }

    // viewportの設定(iOSでの自動ズーム抑止目的)
    this.setViewport();
  },
  watch: {
    $route: function(toRoute) {
      this.$log.info("[app]toRoute.path:" + toRoute.path);

      // パネル拡大モード再設定
      this.setPcPanelMode();

      if (
        toRoute.path.startsWith("/pcfull") ||
        location.pathname.startsWith("/kawabou/twitterCheck") ||
        location.pathname.startsWith("/kawabou/printPreview")
      ) {
        this.$store.commit("app/setMode", "pcfull");
      } else if (toRoute.path.startsWith("/mbfull")) {
        this.$store.commit("app/setMode", "mbfull");
      } else if (toRoute.path.startsWith("/rp")) {
        this.$store.commit("app/setMode", "rp");
      } else if (toRoute.path.startsWith("/mb")) {
        this.$store.commit("app/setMode", "mb");
      } else {
        this.$store.commit("app/setMode", "pc");
      }
    },
    config() {
      // 地図設定情報のストアに設定
      this.$store.commit(
        "map/setMapConfig",
        this.$store.state.app.config.mapConfig
      );
      // 横断設定情報のストアに設定
      this.$store.commit(
        "Telemeter/setCrossConfig",
        this.$store.state.app.config.crossConfig
      );
      // グラフ設定情報のストアに設定
      this.$store.commit(
        "Telemeter/setGraphConfig",
        this.$store.state.app.config.graphConfig
      );
      // 河川予警報設定情報のストアに設定
      this.$store.commit(
        "RiverWarn/setRiverWarnConfig",
        this.$store.state.app.config.riverWarnConfig
      );
      // レーダ設定情報のストアに設定
      this.$store.commit(
        "radar/setRadarConfig",
        this.$store.state.app.config.radarConfig
      );
      // お知らせ設定情報のストアに設定
      this.$store.commit(
        "info/setInformationConfig",
        this.$store.state.app.config.informationConfig
      );
      // 横断設定情報のストアに設定
      this.$store.commit(
        "Swin/setCrossConfig",
        this.$store.state.app.config.crossConfigSw
      );
      // SNS設定情報のストアに設定
      this.$store.commit(
        "sns/setSnsConfig",
        this.$store.state.app.config.snsConfig
      );
      // メッセージ設定情報のストアに設定
      this.$store.commit(
        "Telemeter/setMessageConfig",
        this.$store.state.app.config.messageConfig
      );
      // 個別観測所設定情報のストアに設定
      this.$store.commit(
        "Telemeter/setTmObsConfig",
        this.$store.state.app.config.tmObsConfig
      );

      // 通知許可の表示判定
      this.checkNotification();
      // 観測日時を初期化
      this.$store.commit("app/renewTime");
    },
    appTime() {
      // 最新観測日時、観測日時(ファイル取得用)を更新する
      this.$store.dispatch("app/getCrntTime");
    },
    content() {
      // 表示コンテンツ変更によるページタイトル設定
      if (this.content == "Overview") {
        this.setPageTitle(this.text.pageName.overview);
      } else if (this.content == "RiverwarnList") {
        this.setPageTitle(this.text.pageName.riverwarnList);
      } else if (this.content == "Riverwarn") {
        this.setPageTitle(this.text.pageName.riverwarn);
      } else if (this.content == "TmList") {
        this.setPageTitle(this.text.pageName.tmList);
      } else if (this.content == "TmObs") {
        this.setPageTitle(this.text.pageName.tmObs);
      } else if (this.content == "Radar") {
        this.setPageTitle(this.text.pageName.radar);
      } else if (this.content == "Inundation") {
        this.setPageTitle(this.text.pageName.inundation);
      } else if (this.content == "VcPoint") {
        this.setPageTitle(this.text.pageName.setting);
      } else if (this.content == "VcDefault") {
        this.setPageTitle(this.text.pageName.setting);
      } else if (this.content == "VcCustom") {
        this.setPageTitle(this.text.pageName.setting);
      } else if (this.content == "RegistPoint") {
        this.setPageTitle(this.text.pageName.registPoint);
      } else if (this.content == "Administrator") {
        this.setPageTitle(this.text.pageName.administrator);
      } else if (this.content == "info") {
        this.setPageTitle(this.text.pageName.info);
      } else {
        this.setPageTitle("");
      }
    },
  },
  methods: {
    // 水防団モード設定
    setFldCtlParty() {
      // URL判定
      const fldCtlParty = this.$route.query["fld"];
      if (fldCtlParty != undefined) {
        this.$store.commit("app/setFldCtlParty", fldCtlParty);
      } else {
        // webストレージからストアに設定
        const info = WebStorage.getDefaultInfo();
        // 水防団モードの場合
        if (info.flood) {
          this.$store.commit("app/setFldCtlParty", "1");
        } else {
          this.$store.commit("app/setFldCtlParty", "0");
        }
      }
      // URLに水防団モード付与
      this.routerFldCtlParty();
    },
    // 検索ダイアログの表示有無を設定
    setShowSrchDlg() {
      const srch = this.$route.query["srch"];
      if (srch != undefined && srch == "1") {
        this.$store.commit("search/setShowSrchDlg", true);
      }
    },
    // パネル拡大モード設定
    setPcPanelMode() {
      const ext = this.$route.query["ext"];
      const ovmd = this.$route.query["ovmd"];
      if (ext != undefined && ext == "1") {
        this.$store.commit("app/setPcPanelMode", true);
      } else {
        this.$store.commit("app/setPcPanelMode", false);
      }
      if (ovmd != undefined && ovmd == "tm") {
        this.$store.commit("app/setPcPanelModeContent", "TmOverList");
      } else if (ovmd != undefined && ovmd == "rw") {
        this.$store.commit("app/setPcPanelModeContent", "RwList");
      }
    },
    // 通知許可の表示判定
    checkNotification() {
      const notify = this.$route.query["notify"];
      if (notify && notify === "0") {
        const notification = WebStorage.getNotification();
        // 通知設定が未登録の場合と、未許可で一定期間が過ぎている場合に表示
        if (
          !notification ||
          (!notification.permission &&
            Util.toDate(notification.date) <
              Util.subMonth(
                Util.toDate(),
                this.config.appConfig.NotificationMonth
              ))
        ) {
          // 通知説明を表示
          this.$store.commit("app/setShowNotification", true);
        } else {
          // トークンをストアに格納
          if (notification && notification.token) {
            this.$store.commit("app/setToken", notification.token);
          }
          // 通知の許可状態をストアに格納
          if (notification && notification.permission) {
            let val = false;
            if (notification.permission == "true") {
              val = true;
            }
            this.$store.commit("app/setPermission", val);
          }
        }
      }
    },
    // 水位の表示設定
    setStgMode() {
      let info = WebStorage.getDefaultInfo();
      if (info) {
        if (info.normalstg) {
          this.$store.commit("app/setStgMode", "0");
        } else if (info.topendstg) {
          this.$store.commit("app/setStgMode", "1");
        } else {
          this.$store.commit("app/setStgMode", "0");
        }
      } else {
        this.$store.commit("app/setStgMode", "0");
      }
    },
    // iOSでの自動ズームを抑止するためviewportを設定する
    setViewport() {
      const userAgent = window.navigator.userAgent;
      let viewportContent = "width=device-width,initial-scale=1.0";
      if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("iPad") > -1) {
        // ズームを抑止する設定を追加
        // iOS以外は手動ズームを許容するため設定しない
        // (iOSは設定しても自動ズームのみ抑止され手動ズームは許容される)
        viewportContent = viewportContent + ",user-scalable=no";
      }
      document
        .querySelector("meta[name='viewport']")
        .setAttribute("content", viewportContent);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Kosugi+Maru|Noto+Sans+JP:400,700,900&display=swap");
@import "~leaflet/dist/leaflet.css";
@import "~@ansur/leaflet-pulse-icon/dist/L.Icon.Pulse.css";
@import "./scss/kwb.scss";
@import "./scss/tm.scss";
@import "./scss/tmMb.scss";
@import "./scss/color.scss";
* :not(.v-icon) {
  font-family: "Noto Sans JP", sans-serif !important;
}
.app-frame {
  overflow: hidden;
}
#map {
  width: 200px;
}
.panel {
  width: 550px;
}
.panelLarge {
  position: absolute;
  width: 100%;
  height: calc(100% - 48px);
}
.ap-box-full {
  flex: 1;
  height: 100%;
}
</style>
